export enum BussinessDocumentsClassEnums {
  factura = 1,
  notaCredito = 2,
  notaDebito = 3,
  documSoporte = 4,
  notaDocumSoporte = 5,
  cuentaCobro = 6
}

//Estados de la resolución
export enum BussinessDocumentsResolutionStatusEnums {
  active = 1,
  aboutToExpire = 2,
  expired = 3
}